module.exports = __webpack_public_path__ + "static/img/hpv_banner_mobile.e35eeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hpv_banner_mobile.png
// module id = PX31
// module chunks = 1